export default function initPagination() {
	jQuery('.articles-ajax-box').each(function () {
		var loadHolder = jQuery(this);
		var holder = loadHolder.closest('main');
		var term = loadHolder.attr('data-term');
		var page = 1;
		var currentRequest = null;
		loadContent();

		pagination();

		function loadContent() {
			if (currentRequest !== null) {
				currentRequest.abort();
			}

			currentRequest = jQuery.ajax({
				method: 'POST',
				dataType: 'html',
				data: {
					ajax: loadHolder.attr('data-ajax'),
					term: term,
					tax: loadHolder.attr('data-tax'),
					'ajax-page': page,
					'_': Date.now(),
				},
			});

			currentRequest.done(function (data) {
				currentRequest = null;
				loadHolder.html(data);
				pagination();
			});
		}

		function pagination() {
			var pagination = holder.find('.pagination');
			var paginationBtns = pagination.find('a');

			pagination.find('.active').removeClass('active');
			pagination.find('[data-page="' + page + '"]').addClass('active');

			paginationBtns.off('click').on('click', function (e) {
				e.preventDefault();
				var paginationBtn = jQuery(this);
				pagination.find('.active').removeClass('active');
				page = parseInt(paginationBtn.attr('data-page'));
				term = holder.find('.btn-list [aria-selected="true"]').attr('data-term');
				loadContent();
				jQuery('html').animate({ scrollTop: loadHolder.offset().top - 20 }, 0);
			});
		}
	});
}
